export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-20 pb-16 md:pt-24 md:pb-20 overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              免费追剧 · 海量资源 · 每日更新
            </div>

            <h1 className="font-heading font-bold text-foreground-950 text-3xl md:text-4xl lg:text-5xl leading-tight mb-4">
              6080新视觉影视
              <br className="hidden sm:block" />
              <span className="text-primary-500">免费高清影视</span>，随时随地想看就看
            </h1>

            <p className="text-primary-600 font-heading font-medium text-lg md:text-xl mb-5">
              全网热门影视一站畅享，不花一分钱
            </p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              6080新视觉影视致力于打造最全免费影视平台，收录海量电影、热播电视剧、热门综艺以及动漫番剧。
              每日同步更新最新剧集，无需注册登录，打开即看，流畅高清播放体验。无论是最新上映的院线大片，
              还是经典老片、小众佳作，在这里都能找到。追剧不等待，好片看不停。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <p className="font-heading font-bold text-2xl md:text-3xl text-primary-500">20000+</p>
                <p className="text-xs text-foreground-500 mt-1">海量片源</p>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <p className="font-heading font-bold text-2xl md:text-3xl text-primary-500">每日更新</p>
                <p className="text-xs text-foreground-500 mt-1">同步追剧</p>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <p className="font-heading font-bold text-2xl md:text-3xl text-primary-500">完全免费</p>
                <p className="text-xs text-foreground-500 mt-1">无需付费</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                type="button"
                onClick={() => handleNavClick('#cards')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始观看
              </button>
              <button
                type="button"
                onClick={() => handleNavClick('#about')}
                className="w-full sm:w-auto px-8 py-3 border border-background-300 hover:border-primary-400 hover:text-primary-500 text-foreground-700 font-medium text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-200/30 rounded-2xl blur-xl"></div>
              <div className="relative bg-background-50 rounded-2xl overflow-hidden border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20movie%20poster%20collage%20with%20popular%20Chinese%20dramas%20and%20films%2C%20cinematic%20atmosphere%2C%20warm%20theater%20lighting%20on%20red%20velvet%20background%2C%20film%20reel%20and%20spotlight%20elements%2C%20entertainment%20and%20streaming%20vibe%2C%20professional%20movie%20poster%20design%2C%20rich%20contrast%2C%20dramatic%20lighting&width=800&height=1000&seq=hero-main-2026&orientation=portrait"
                  alt="6080新视觉影视热门影视推荐"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                  <span className="px-2 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">热播中</span>
                  <span className="text-background-50 text-xs font-medium">每日更新热门影视资源</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}